export function Spinner() {
  return (
    <div className="flex justify-center items-center py-16">
      <span className="text-text-muted text-xs animate-pulse">loading...</span>
    </div>
  );
}
